<template>
  <div class="hxifmnpage">
    <div class="view_page">
      <div class="page_head"></div>
      <div class="page_body">
        <div class="content">
          <div class="ct_text">
            <div
              style="width:100%;height:15%;background:rgba(255,255,255,1);border-radius:16px;margin-top:1%;"
            >
              <img
                src="../../../resource/img/WeChatbfaed0e8af0e4c8e8548f1f00bfb909e.png"
                alt
                class="kximg"
              />
              <div class="hxtext">
                <ul>
                  <li>
                    <font
                      style="font-family:PingFangSC-Regular;font-weight:400;color:rgba(0,0,0,1);font-size:15.5px;"
                    >
                      张振
                      <span style="float:right;color:rgba(70,70,70,1);font-size:12.5px;">x4</span>
                    </font>
                  </li>
                  <li>
                    <font style="color:rgba(143,143,143,1)">1218637672455</font>
                  </li>
                  <li>
                    <font style="color:rgba(143,143,143,1)">获取时间2019-03-29 13：00</font>
                  </li>
                  <li>
                    <font style="color:rgba(143,143,143,1)">免单内容：大保健项目满200减99元</font>
                  </li>
                  <li>
                    <font
                      style="float:right;color:rgba(143,143,143,1);margin-top:4%"
                    >截止日期：2019-10-09</font>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div class="ct_card">
            <div class="bjcard" v-for="(item,index) in OrderInfo" :key="index">
              <div class="cardrowone">
                <img
                  src="../../../resource/img/qia.png"
                  alt
                  style="float:left;width:5%;heihgt:4%;margin-top: 2%;"
                />
                <table style="float:left;width:75%">
                  <tr>
                    <th>{{item.productName}}</th>
                  </tr>
                  <tr style="height:2px;"></tr>
                  <tr>
                    <td style="width:10%">总数</td>
                    <td style="width:10%">已使用</td>
                    <td style="width:3%">剩余</td>
                  </tr>
                  <tr style="height:2px;"></tr>
                  <tr>
                    <td style="width:10%">{{item.buyNum}}</td>
                    <td style="width:10%">{{item.useNum}}</td>
                    <td style="width:3%">{{item.buyNum-item.useNum}}</td>
                  </tr>
                </table>
              </div>
              <div class="cardrowtwo">
                <img
                  src="../../../resource/img/shijian.png"
                  alt
                  style="float:left;width:4%;heihgt:4%;margin-top: 2%;margin-left:4%;"
                />
                <table style="float:left;width:75%">
                  <tr>
                    <th style="height:20px;line-height:20px">使用时间</th>
                  </tr>
                  <tr style="height:5px;"></tr>
                  <tr v-for="(items,indexs) in item.useDetailList" :key="indexs">
                    <td style="width:30%" v-if="items.useTime!=null">{{items.useTime}}</td>
                  </tr>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "MerUnionmbHxinformation",
  data() {
    return {
      urlParam: {},
      OrderInfo: []
    };
  },
  created() {
    this.urlParam = this.$route.params;
    console.log(this.urlParam);
    this.LmkOrderInfo();
  },
  methods: {
    LmkOrderInfo: function() {
      var that = this;
      that.$axios
        .post(
          "/mer/merUnion/user/findOrderInfo.do",
          that.$qs.stringify({
            storeId: that.urlParam.storeId,
            activityId: that.urlParam.activityId,
            uid: that.urlParam.uid
          })
        )
        .then(response => {
          console.log(response);
          that.OrderInfo = response.data.list;
        })
        .catch(function(error) {
          //请求失败处理
          console.log(error);
        });
    }
  }
};
</script>
<style scoped>
ul {
  list-style: none;
  padding: 0px;
}
li {
  margin-top: 2%;
}
.hxifmn {
  width: 100%;
  height: 100%;
}
.page_head {
  width: 100%;
  height: 40vh;
  background-image: url("../../../resource/img/Nipic_12106414_20160922174257880038.png");
}
.page_body {
  width: 100%;
  height: 60vh;
  background: rgba(242, 242, 242, 1);
  display: flex;
  justify-content: center;
}
.content {
  width: 92%;
  height: 80vh;
  border-radius: 20px 20px 20px 20px;
  position: relative;
  top: -52%;
  /* flex-direction: column;  */
}
.ct_text {
  width: 100%;
  height: 23%;
  background: rgba(255, 255, 255, 1);
  border-radius: 20px;
  border: none;
}
.ct_card {
  width: 100%;
  height: 60%;
  margin-top: 5%;
  background-color: white;
  border-radius: 20px;
  border: none;
}
.kximg {
  width: 20%;
  height: 10vh;
  padding-left: 4%;
  padding-top: 4%;
  float: left;
}
.hxtext {
  width: 70%;
  height: 100%;
  padding-left: 2%;
  padding-top: 2%;
  float: left;
}
.bjcard {
  width: 90%;
  height: 45%;
  text-align: left;
  margin-left: 6%;
  margin-top: 3%;
  border-top: 1px solid #e5e5e5;
}
.cardrowone {
  width: 100%;
  height: 40%;
}
.cardrowtwo {
  width: 100%;
  height: 38%;
  border-top: 1px solid #e5e5e5;
  color: #bfbfbf;
}
</style>



// WEBPACK FOOTER //
// src/components/active/member/MerUnionmbHxinformation.vue